import SentMessages from "./sent-messages"

export default SentMessages